import en from './en.js'; // 英文
import zh from './zh.js'; // 中文
import it from './it.js'; // 意大利语
import de from './de.js'; // 德语
import es from './es.js'; // 西班牙语
import fr from './fr.js'; // 法语
import hr from './hr.js'; // 克罗地亚语
import sl from './sl.js'; // 斯洛文尼亚语
import hu from './hu.js'; // 匈牙利语
import sr from './sr.js'; // 塞尔维亚语


export default {
  en: en,
  'zh-CN': zh,
  it: it,
  de: de,
  es: es,
  fr: fr,
  hr: hr,
  sl: sl,
  hu: hu,
  sr: sr,
}



// WEBPACK FOOTER //
// ./src/i18n/langs/index.js